import React, {useState, useEffect} from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import OviChart from "../Dashboard/OviChart";

const OrgOviSummary = (props) => {

    const [translation] = useTranslation("translations");
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const { organization_id, team_id, sub_team_id } = useParams();

    const [loading, setLoading] = useState(false);
    const [companyOviData, setCompanyOviData] = useState([]);

    useEffect(() => {

        let dataKey = `sy_org_${organization_id}_ovi_data`;

        if ( sub_team_id ) {
            dataKey = `sy_org_${organization_id}_team_${sub_team_id}_ovi_data`;
        } else if ( team_id ) {
            dataKey = `sy_org_${organization_id}_team_${team_id}_ovi_data`;
        }

        const orgOviData = getWithExpiry( dataKey );

        if ( orgOviData ) {
            setCompanyOviData(  orgOviData );
        }


    }, [organization_id, team_id, sub_team_id]);

    const handleCompanyOvi = async () => {

        setLoading( true );

        let userRequestData = new FormData();
        userRequestData.append( 'token', cookies.sustainyou_user_jwt );
        userRequestData.append( 'company_id', organization_id );
        userRequestData.append( 'ovi', 'ovi' );

        if ( sub_team_id ) {
            userRequestData.append( 'team_id', sub_team_id );
        } else if ( team_id ) {
            userRequestData.append( 'team_id', team_id );
        }

        const fetchUrl = `${configVars.apiUrl}sustainteams/v1/sustaingetcompanyhvi/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                method: "POST",
                headers: {
                    Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
                }
            );
            
            const companyResponse = await response.json();
    
            if ( companyResponse ) {

                //console.log( companyResponse );

                if ( companyResponse?.data?.company_result && companyResponse?.data?.company_result?.length > 0 ) {

                    let companyOvi = [];

                    companyResponse.data.company_result.map( (item) => {
                        let itemOvi = null;

                        if (item.ovi && item.ovi.length > 0 ) {
                            
                            itemOvi = JSON.parse( item.ovi );
                            const recentOvi = [...itemOvi].pop();

                            itemOvi = itemOvi.reverse().filter((value, index, self) =>
                                index === self.findIndex((t) => (
                                    t.date === value.date
                                ))
                            )
                            
                            companyOvi.push({
                                user_id: parseInt( item.user_id, 10 ),
                                member_ovi_all: itemOvi,
                                member_ovi: recentOvi
                            });
                        }

                        return itemOvi;
                    })

                    const orgOviData = {
                        members_count: companyResponse?.data?.company_result?.length,
                        organization: companyOvi,
                        personal: []
                    }

                    setCompanyOviData(orgOviData);

                    let dataKey = `sy_org_${organization_id}_ovi_data`;

                    if ( sub_team_id ) {
                        dataKey = `sy_org_${organization_id}_team_${sub_team_id}_ovi_data`;
                    } else if ( team_id ) {
                        dataKey = `sy_org_${organization_id}_team_${team_id}_ovi_data`;
                    }

                    setWithExpiry( dataKey, orgOviData );

                }

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

        setLoading( false );

    }

    return (
        <div className="row">
            <div className="col-12">

                <div className="row">
                    <div className={`col-12 d-flex flex-column flex-lg-row align-items-center ${companyOviData && companyOviData?.length > 0 ? '' : 'justify-content-end'}`}>

                        {(!companyOviData || companyOviData?.length === 0) &&
                            <h4 className="flex-grow-1 text-center text-lg-start mb-3 mb-lg-1">{translation("process_latest_des")}</h4>
                        }

                        <button type="button" className="btn btn-halite-blue rounded-pill" onClick={() => handleCompanyOvi()}>
                            {loading &&
                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            }
                            {!loading &&
                                <i className="fa fa-database" aria-hidden="true"></i>
                            }
                            <span className="ps-3">{translation("process_latest_btn")}</span>
                        </button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <OviChart ovi={companyOviData} loading={loading} organization={ organization_id } roles={props?.roles} gtg={false} />
                    </div>
                </div>

            </div>
        </div>
    )

}

export default OrgOviSummary;